import FeedList from "../Components/FeedList";
import PostForm from "../Components/PostForm";

export default function Feed() {
  return (
    <>
      <PostForm />
      <hr />
      <FeedList />
    </>
  );
}
